import { useMediaQuery } from 'react-responsive'

import React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { primary } from '../../components/constants/colors'
import { SiteViewModel } from '../ViewModel'

const headCells = [
  {
    id: 'siteCode',
    disablePadding: true,
    label: 'Site Code',
  },
  {
    id: 'siteName',
    disablePadding: false,
    label: 'Site Name',
  },
  {
    id: 'catchment',
    disablePadding: false,
    label: 'Catchment',
  },
  {
    id: 'region',
    disablePadding: false,
    label: 'Region',
  },
  {
    id: 'waterway',
    disablePadding: false,
    label: 'Waterway',
  },
  {
    id: 'latitude',
    disablePadding: false,
    label: 'Latitude',
  },
  {
    id: 'longtitude',
    disablePadding: false,
    label: 'longtitude',
  },
  {
    id: 'zone',
    disablePadding: false,
    label: 'Zone',
  },
]

interface SiteTableProps {
  sites: SiteViewModel[]
  onSelectedSite: (id: string) => void
}

function SitesTable({ sites, onSelectedSite }: SiteTableProps) {
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` })

  return (
    <TableContainer
      component={Paper}
      style={{
        minHeight: isMobile ? 200 : 650,
        height: isMobile ? '30vh' : '70vh',
      }}
    >
      <Table
        stickyHeader
        aria-label="simple table"
        id="my-table" //jsautopdf uses this id to generate pdf
      >
        <TableHead style={{ backgroundColor: primary }}>
          <TableRow>
            {headCells.map((headCell) => (
              <TableCell
                key={headCell.id}
                padding={headCell.disablePadding ? 'none' : 'normal'}
              >
                {headCell.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sites.map((item) => {
            return (
              <TableRow
                hover
                key={item.id.toString()}
                onClick={() => onSelectedSite(item.id)}
              >
                <TableCell>{item.id}</TableCell>
                <TableCell>{item.siteName}</TableCell>
                <TableCell>{item.catchment}</TableCell>
                <TableCell>{item.region}</TableCell>
                <TableCell>{item.waterway}</TableCell>
                <TableCell>{item.latitude}</TableCell>
                <TableCell>{item.longitude}</TableCell>
                <TableCell>{item.zone}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SitesTable
